import styled from 'styled-components';
import _Container from 'components/Container';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Container = styled(_Container)`
  max-width: initial;
  padding: 0;
  background-color: ${th('colors.white')};
  color: ${th('colors.black')};
`;

export const Header = styled.div`
  width: 100%;
  padding: 80px 32px 16px 32px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};
  z-index: 1;
  @media ${sizes.desktop} {
    padding: 93px 48px 32px 48px;
  }
  > h1 {
    font-size: 32px;
    @media ${sizes.desktop} {
      font-size: 40px;
    }
  }
  > div {
    padding-top: 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  @media ${sizes.desktop} {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  padding: 32px 32px 48px 32px;
  color: ${th('colors.black')};

  > h2 {
    color: #c76358;
    font-size: 20px;
    margin: 0 0 20px 0;

    :not(:first-child) {
      margin: 40px 0 20px 0;
    }
  }

  > h3 {
    font-size: 16px;
    font-weight: bold;
    margin: 24px 0 10px 0;
  }

  @media ${sizes.tabletPortrait} {
    padding: 48px 48px 4rem 48px;
  }
  @media ${sizes.desktop} {
    max-width: 800px;
    padding: 48px 48px 4rem 48px;
  }
  > p > a,
  > p > b > a {
    color: ${({ theme }) => theme.colors.turquoise};
  }
`;

export const Image = styled.img`
  position: fixed;
  right: 32px;
  top: 290px;
  width: 400px;
  display: none;
  @media ${sizes.desktop} {
    display: block;
  }
  @media ${sizes.extraLargeDesktop} {
    width: 500px;
    right: 96px;
  }
`;
